import { sample } from '@sama/micro-dash';
import { Answer } from '../../team-apis/otterdam/answers/answer';
import { MultilevelMenuOutput } from '../../team-apis/otterdam/outputs/multilevel-menu-output';
import { OutputHelper } from './output-helper';

export class MultilevelMenuOutputHelper extends OutputHelper<MultilevelMenuOutput> {
  override supportsDefaultAnswer = true;

  override getLabelFor(
    answer: Answer | undefined,
    output: MultilevelMenuOutput,
  ): string {
    return stripMultilevelSyntax(
      this.getMatchingAnswerOptionLabel(answer, output),
    )
      .split('|')
      .map((str) => str.trim())
      .reverse()
      .join(' | ');
  }

  override makeRandomAnswer(output: MultilevelMenuOutput) {
    return sample(output.answer_options).name;
  }
}

export function stripMultilevelSyntax(label: string) {
  return label.replace(/^\s*\[\[.*]]\s*/, '');
}
